import { cn } from "@/lib/utils";

/** Consistent page header: title + optional description + actions (right on desktop, below on mobile). */
export const PageHeader = ({ title, description, actions, className, testid }) => (
  <div
    data-testid={testid}
    className={cn("flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between", className)}
  >
    <div className="min-w-0">
      {title && (
        <h1 className="font-heading text-2xl font-bold tracking-tight text-foreground sm:text-3xl">{title}</h1>
      )}
      {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
  </div>
);
